import React from 'react';
import PropTypes from 'prop-types';
import ReactSlider from 'react-slider';
import styles from './Slider.module.scss';
import omit from 'lodash-es/omit';

export default function Slider(props) {
  const highlightTrackIdx =
    props.value == null || typeof props.value === 'number'
      ? 0
      : props.value.length - 1;
  /* eslint-disable */
  return (
    <ReactSlider
      className={styles.ghSlider}
      thumbClassName={styles.sliderThumb}
      trackClassName={styles.sliderTrack}
      renderTrack={(trackProps, state) => {
        let classes = [
          trackProps.key === styles.sliderTrack + `-${highlightTrackIdx}`
            ? styles.highlighted
            : '',
          props.disabled ? styles.disabledTrack : '',
        ].join(' ');

        return (
          <div
            {...trackProps}
            className={trackProps.className + ' ' + classes}
          />
        );
      }}
      renderThumb={(thumbProps, state) => {
        let classes = [props.disabled ? styles.disabledThumb : ''].join(' ');

        return (
          <div {...thumbProps} className={thumbProps.className + ' ' + classes}>
            <div className={styles.handleDot} />
            {props.showLabel ? (
              <div className={styles.handleLabel}>
                { props.labelFormatter != null ? props.labelFormatter(thumbProps, state) : state.valueNow}
              </div>
            ) : null}
          </div>
        );
      }}
      {...omit(props, ['showLabel', 'labelFormatter'])}
    />
  );
}
/* eslint-enable */
Slider.propTypes = {
  showLabel: PropTypes.bool,
  // labelSuffix: PropTypes.string,
  labelFormatter: PropTypes.func,
  value: PropTypes.array || PropTypes.number,
};
